__turbopack_context__.v({
  "blue": "InfoItem-module-scss-module__FMjkia__blue",
  "container": "InfoItem-module-scss-module__FMjkia__container",
  "green": "InfoItem-module-scss-module__FMjkia__green",
  "item": "InfoItem-module-scss-module__FMjkia__item",
  "line": "InfoItem-module-scss-module__FMjkia__line",
  "list": "InfoItem-module-scss-module__FMjkia__list",
  "pink": "InfoItem-module-scss-module__FMjkia__pink",
});
